module.exports = __webpack_public_path__ + "img/5e51a5f.jpg";